/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Editors_Name_TitleInputs */

const en_us2_profile_editors_name_title = /** @type {(inputs: Profile_Editors_Name_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What should we call you?`)
};

const pt_br2_profile_editors_name_title = /** @type {(inputs: Profile_Editors_Name_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Como você quer ser chamado?`)
};

const es_419_profile_editors_name_title = /** @type {(inputs: Profile_Editors_Name_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Cómo quieres que te llamemos?`)
};

const pt_pt2_profile_editors_name_title = /** @type {(inputs: Profile_Editors_Name_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Como queres ser tratado?`)
};

const fr_fr2_profile_editors_name_title = /** @type {(inputs: Profile_Editors_Name_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comment veux-tu qu'on t'appelle ?`)
};

const de_de2_profile_editors_name_title = /** @type {(inputs: Profile_Editors_Name_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wie sollen wir dich nennen?`)
};

const it_it2_profile_editors_name_title = /** @type {(inputs: Profile_Editors_Name_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Come vuoi essere chiamato?`)
};

/**
* | output |
* | --- |
* | "What should we call you?" |
*
* @param {Profile_Editors_Name_TitleInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_editors_name_title = /** @type {((inputs?: Profile_Editors_Name_TitleInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Editors_Name_TitleInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_editors_name_title(inputs)
	if (locale === "es-419") return es_419_profile_editors_name_title(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_editors_name_title(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_editors_name_title(inputs)
	if (locale === "de-DE") return de_de2_profile_editors_name_title(inputs)
	if (locale === "it-IT") return it_it2_profile_editors_name_title(inputs)
	return en_us2_profile_editors_name_title(inputs)
});
export { profile_editors_name_title as "profile-editors.name_title" }